import { useEffect } from 'react';
import { Event } from '../helper';

export default function useEvent<T>(event: Event<T>, callback: (args: T) => void) {
	useEffect(() => {
		event.subscribe(callback);
		return () => event.unsubscribe(callback);
	}, [callback, event]);
}
